import propTypes from "prop-types";

const Button = ({ text, onClick, cname }) => {
  return (
    <button className={cname} onClick={onClick}>
      {text}
    </button>
  );
};

Button.propTypes = {
  text: propTypes.string,
  onClick: propTypes.func,
};

export default Button;
